import React from 'react';
import {SelectInput, FormDataConsumer} from 'react-admin';
import {addField} from 'ra-core';

const FiltersNestedSelectInput = props => {
    // eslint-disable-next-line react/prop-types
    const {source, fstSource, sndSource, fstLabel, sndLabel, fstChoices, getSndChoices, validate} = props;

    const getSndChoicesFromFirstValueId = valueID => {
        // eslint-disable-next-line react/prop-types
        const fstChoice = fstChoices.find(c => c.id === valueID);
        return fstChoice ? getSndChoices(fstChoice) : [];
    };

    const firstLevelSourceName = `${source}_${fstSource}`;
    return (
        <>
            <SelectInput
                source={firstLevelSourceName}
                choices={fstChoices}
                label={fstLabel}
                className="colInput"
                validate={validate}
            />
            &nbsp;
            <FormDataConsumer>
                {({formData, ...rest}) => {
                    const choices = formData[firstLevelSourceName] ? getSndChoicesFromFirstValueId(formData[firstLevelSourceName]) : [];
                    return formData &&
                        (
                            <SelectInput
                                source={`${firstLevelSourceName}_${sndSource}`}
                                choices={choices}
                                label={sndLabel}
                                className="colInput"
                                validate={validate}
                                initialValue={null}
                                {...rest}
                            />
                        )
                }
                }
            </FormDataConsumer>
        </>
    );
};

export default addField(FiltersNestedSelectInput);
